import InventarioTableUI from "../components/InventarioTableUI";

export default function InventarioTable({
  headerData,
  bodyData,
  onSelect,
  showCheckbox,
  selectedRows,
  setSelectedRows,
  checkboxLabel,
  priceIncrease,
  filters,
}) {
  const handleSelectRow = (rowId) => {
    const newSelected = selectedRows.includes(rowId)
      ? selectedRows.filter((id) => id !== rowId)
      : [...selectedRows, rowId];
    setSelectedRows(newSelected);
    onSelect(newSelected);
  };

  const filteredData = bodyData.filter((product) => {
    const matchesName = !filters.name || product.name.toLowerCase().includes(filters.name.toLowerCase());
    const matchesType = !filters.type || product.product_type?.type === filters.type;
    const matchesPrice = product.price >= filters.priceRange[0] && product.price <= filters.priceRange[1];
    return matchesName && matchesType && matchesPrice;
  });

  return (
    <InventarioTableUI
      data={filteredData}
      headerData={headerData}
      onRowToggle={handleSelectRow}
      showCheckbox={showCheckbox}
      selectedRows={selectedRows}
      checkboxLabel={checkboxLabel}
      priceIncrease={priceIncrease}
    />
  );
}
